import React from "react";
import KoIcon from "@kwapio/icons";
import styles from "./status.module.scss";

function Status(props) {
  let { data, bool, row } = props;

  const isLeave = Boolean(row?.leaveId);
  const isExpense = Boolean(row?.expenseId);
  const isPrice = Boolean(row?.price);

  let finalStatus = "";

  switch (data) {
  case 1:
    finalStatus = "Active";
    if (isLeave || isExpense) finalStatus = "Waiting";
    if (isPrice) finalStatus = "Published";
    break;

  case 2:
    if (isLeave || isExpense) finalStatus = "Approved";
    else finalStatus = "Active";
    break;

  case 3:
    if (isLeave || isExpense) finalStatus = "Rejected";
    else finalStatus = "Suspended";
    break;

  case -1:
    finalStatus = "Deleted";
    break;

  case true:
    finalStatus = "Yes";
    break;

  case false:
    finalStatus = "No";
    break;
  case 0:
    if (isLeave || isExpense || isPrice) finalStatus = "Draft";
    else finalStatus = "Suspended";
    break;

  default:
    finalStatus = "Suspended";
    break;
  }

  console.log("finalStatus =", finalStatus);

  return bool ? (
    <div className={styles.wrapper}>
      {finalStatus === "Yes" || finalStatus === "Active" ? (
        <KoIcon name="TickFilled" />
      ) : (
        <KoIcon name="CrossFilled" />
      )}
    </div>
  ) : (
    <div className={styles.wrapper}>
      <div
        className={`${styles.status} ${
          styles[finalStatus.replaceAll(" ", "")]
        }`}
      >
        <div className={styles.text}>{finalStatus}</div>
      </div>
    </div>
  );
}

export default Status;
